export default __webpack_public_path__ + "static/safari-pinned-tab-d3086c1114713d4e67073badaf35b37c.svg";